export interface FeaturedApp {
	id: string;
	name: string;
	description: string;
	schemes: string[];
	appStoreUrl?: string;
	webUrl: string;
}

export const featuredApps: FeaturedApp[] = [
	{
		id: "draftkings",
		name: "DraftKings",
		description: "Daily fantasy and sportsbook.",
		schemes: ["draftkings"],
		appStoreUrl:
			"https://apps.apple.com/us/app/draftkings-sports-casino/id1375031369",
		webUrl: "https://sportsbook.draftkings.com",
	},
	{
		id: "fanduel",
		name: "FanDuel",
		description: "Fantasy sports, sportsbook, and casino.",
		schemes: ["fanduel", "fanduelapp"],
		appStoreUrl:
			"https://apps.apple.com/us/app/fanduel-sportsbook-casino/id1413721906",
		webUrl: "https://www.fanduel.com",
	},
	{
		id: "sleeper",
		name: "Sleeper",
		description: "Fantasy football, basketball, and pick'em.",
		schemes: ["sleeper"],
		webUrl: "https://sleeper.com",
	},
	{
		id: "espn-fantasy",
		name: "ESPN Fantasy",
		description: "Fantasy leagues, scores, and news.",
		schemes: ["espn", "sportscenter"],
		webUrl: "https://www.espn.com/fantasy/",
	},
	{
		id: "yahoo-fantasy",
		name: "Yahoo Fantasy",
		description: "Fantasy leagues, waivers, and scores.",
		schemes: ["yahoofantasysports", "yahoosports"],
		webUrl: "https://football.fantasysports.yahoo.com",
	},
	{
		id: "underdog",
		name: "Underdog Fantasy",
		description: "Best ball, pick'em, and draft contests.",
		schemes: ["underdog", "underdogfantasy"],
		webUrl: "https://underdogfantasy.com",
	},
	{
		id: "prizepicks",
		name: "PrizePicks",
		description: "Player-prop pick'em contests.",
		schemes: ["prizepicks"],
		appStoreUrl:
			"https://apps.apple.com/us/app/prizepicks-sports-picks/id1437843273",
		webUrl: "https://app.prizepicks.com",
	},
	{
		id: "betmgm",
		name: "BetMGM",
		description: "Sportsbook, casino, and promotions.",
		schemes: ["betmgm"],
		appStoreUrl:
			"https://apps.apple.com/us/app/betmgm-sportsbook-casino/id1430875409",
		webUrl: "https://sportsbook.betmgm.com",
	},
	{
		id: "caesars",
		name: "Caesars Sportsbook",
		description: "Sportsbook with odds and live betting.",
		schemes: ["caesars", "caesarssportsbook", "williamhill"],
		appStoreUrl:
			"https://apps.apple.com/us/app/caesars-sportsbook-casino/id1413099571",
		webUrl: "https://sportsbook.caesars.com",
	},
	{
		id: "bet365",
		name: "bet365",
		description: "Sportsbook with live betting and streams.",
		schemes: ["bet365"],
		webUrl: "https://www.bet365.com",
	},
	{
		id: "fanatics",
		name: "Fanatics Sportsbook",
		description: "Sportsbook and rewards program.",
		schemes: ["fanatics", "fanaticssportsbook"],
		appStoreUrl:
			"https://apps.apple.com/us/app/fanatics-sports-casino/id1616738407",
		webUrl: "https://sportsbook.fanatics.com",
	},
];
